/**
 * TakeTestStep
 *
 * Extracted from LanguageTestModal — Step 2: Take Test with
 * external link to test platform and screenshot reminder.
 */

import type { TFunction } from 'i18next';
import { Button, Card, CardContent } from '@tonnie/ui';
import { AlertTriangle, ExternalLink } from '@tonnie/assets';
import { motion } from 'framer-motion';

import type { ILanguageTestConfig } from './language-test.types';

export function TakeTestStep({
  testConfig: _testConfig,
  hasOpenedTest,
  onOpenTest,
  t,
}: {
  testConfig: ILanguageTestConfig;
  hasOpenedTest: boolean;
  onOpenTest: () => void;
  t: TFunction;
}) {
  return (
    <div className="p-6 flex flex-col items-center justify-center min-h-[400px] space-y-8">
      {/* Open test CTA */}
      <Card className="border-2 border-primary/30 bg-linear-to-br from-primary/5 to-background w-full max-w-lg">
        <CardContent className="p-8 text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
            <ExternalLink className="w-8 h-8 text-primary-accessible" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-foreground mb-1">
              {t('checkup.languageTests.readyToStart')}
            </h3>
            <p className="text-sm text-muted-foreground">
              {t('checkup.languageTests.openPlatformHint')}
            </p>
          </div>
          <Button onClick={onOpenTest} size="lg" className="gap-2 px-8">
            <ExternalLink className="w-4 h-4" />
            {t('checkup.languageTests.openPlatform')}
          </Button>
          {hasOpenedTest && (
            <motion.p
              initial={{ opacity: 0, y: 5 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-xs text-success-accessible font-medium"
            >
              {t('checkup.languageTests.testOpened')}
            </motion.p>
          )}
        </CardContent>
      </Card>

      {/* Screenshot reminder */}
      <Card className="border border-tone-amber-line bg-tone-amber-subtle w-full max-w-lg">
        <CardContent className="p-4 flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-tone-amber shrink-0 mt-0.5" />
          <div>
            <span className="text-sm font-semibold text-tone-amber block mb-1">
              {t('checkup.languageTests.screenshotReminder')}
            </span>
            <span className="text-xs text-tone-amber">
              {t('checkup.languageTests.screenshotReminderDetail')}
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
